import Service from './service'
export var ApiUserMessageType;
(function (ApiUserMessageType) {
  ApiUserMessageType["USER_HAS"] = "user.has.user"
  ApiUserMessageType["USER_LOST"] = "user.lost.user"
  ApiUserMessageType["USER_DATABASE_REQUEST"] = "database.user.request"
  ApiUserMessageType["USER_DATABASE_RESPONSE"] = "database.user.response"
})(ApiUserMessageType || (ApiUserMessageType = {}))
export var DatabasePersonSource;
(function (DatabasePersonSource) {
  /** База робота */
  DatabasePersonSource[DatabasePersonSource["Robot"] = 1] = "Robot"
  /** База робота */
  DatabasePersonSource[DatabasePersonSource["Owner"] = 2] = "Owner"
  /** база знаменитостей */
  DatabasePersonSource[DatabasePersonSource["General"] = 4] = "General"
  /** RESERVED */
  DatabasePersonSource[DatabasePersonSource["Global"] = 8] = "Global" // only acquainted
})(DatabasePersonSource || (DatabasePersonSource = {}))

/**
 * Сервис для работы с базой пользователей
 * @version 0.0.1
 * @since 1.9.0
 */
export default class UserService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiUserMessageType.USER_DATABASE_RESPONSE:
          if (typeof message.response.get_user !== 'undefined') {
            if (message.response.get_user === false) {
              this.reject(this.waiters.getUser, message.response.status)
            }
            else {
              this.resolve(this.waiters.getUser, message.response.get_user)
            }
          }
          else if (message.response.del_user === true) {
            this.resolve(this.waiters.deleteUser, message.response.del_user)
          }
          else if (message.response.del_user === false) {
            this.reject(this.waiters.deleteUser, message.response.status)
          }
          else if (message.response.add_user === true) {
            this.resolve(this.waiters.addUser, message.response.add_user)
          }
          else if (message.response.add_user === false) {
            this.reject(this.waiters.addUser, message.response.status)
          }
          else if (message.response.upd_user === true) {
            this.resolve(this.waiters.updateUser, message.response.upd_user)
          }
          else if (message.response.upd_user === false) {
            this.reject(this.waiters.updateUser, message.response.status)
          }
          break
      }
    }
    this.waiters = {
      addUser: [],
      getUser: [],
      updateUser: [],
      deleteUser: [],
    }
    this.messageChannel.subscribe(ApiUserMessageType.USER_HAS, messageHandler)
    this.messageChannel.subscribe(ApiUserMessageType.USER_LOST, messageHandler)
    this.messageChannel.subscribe(ApiUserMessageType.USER_DATABASE_RESPONSE, messageHandler)
  }
  /**
     * Добавить пользователя
     * @since 1.9.0
     *
     * @param {AddedDatabaseUser} data - данные пользователя
     * @return {*}  {Promise<boolean>}
     * @memberof UserService
     *
     * @example <caption>Добавить пользователя</caption>
     * robot.userService.addUser(data).then((success) => {
     *   console.log('user added')
     * }).catch(reason => { console.log(reason) })
     */
  addUser(data) {
    return this.execute({
      type: ApiUserMessageType.USER_DATABASE_REQUEST,
      add_user: data,
    }, this.waiters.addUser)
  }
  /**
     * Получить пользователя по id
     * @since 1.9.0
     *
     * @param {number} id - id пользователя в базе
     * @return {*}  {Promise<DatabaseUser>}
     * @memberof UserService
     *
     * @example <caption>Получить пользователя по id</caption>
     * robot.userService.getUser(id).then((user) => {
     *   console.log('user name', user.name)
    * }).catch(reason => { console.log(reason) })
     */
  getUser(id) {
    return this.execute({
      type: ApiUserMessageType.USER_DATABASE_REQUEST,
      get_user: id,
    }, this.waiters.getUser)
  }
  /**
     * Удалить пользователя по id
     * @since 1.9.0
     *
     * @param {number} id - id пользователя в базе
     * @return {*}  {Promise<boolean>}
     * @memberof UserService
     *
     * @example <caption>Удалить пользователя по id</caption>
     * robot.userService.getUser(id).then((success) => {
     *   console.log('user deleted')
    * }).catch(reason => { console.log(reason) })
     */
  deleteUser(id) {
    return this.execute({
      type: ApiUserMessageType.USER_DATABASE_REQUEST,
      del_user: id,
    }, this.waiters.deleteUser)
  }
  /**
     * Обновить пользователя по id
     * @since 1.9.0
     *
     * @param {DatabaseUser} data - данные пользователя
     * @return {*}  {Promise<boolean>}
     * @memberof UserService
     *
     * @example <caption>Удалить пользователя по id</caption>
     * robot.userService.updateUser(data).then((success) => {
     *   console.log('user updated')
    * }).catch(reason => { console.log(reason) })
     */
  updateUser(data) {
    return this.execute({
      type: ApiUserMessageType.USER_DATABASE_REQUEST,
      upd_user: data,
    }, this.waiters.updateUser)
  }
  /** @deprecated */
  onUserPresence(_callback) {
    // ...
  }
  /** @eprecated */
  onUserLost(_callback) {
    // ...
  }
}
